import WYSIWYG from './WYSIWYG';

export * from './WYSIWYG';

export default WYSIWYG;
